var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "modal-body" }, [
      _c(
        "form",
        {
          staticClass: "m-form m-form--state",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "m-portlet__body" },
            [
              _c("div", { staticClass: "form-group m-form__group row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-lg-12",
                    class: { "has-danger": _vm.errors.has("key") }
                  },
                  [
                    _c("label", [_vm._v(_vm._s(_vm._f("translate")("key")))]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phrase.key,
                          expression: "phrase.key"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:2|max:50|unique",
                          expression: "'required|min:2|max:50|unique'"
                        }
                      ],
                      staticClass: "form-control m-input",
                      attrs: { type: "text", name: "key" },
                      domProps: { value: _vm.phrase.key },
                      on: {
                        keyup: _vm.formatKey,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.phrase, "key", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("key"),
                            expression: "errors.has('key')"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [_vm._v(" " + _vm._s(_vm.errors.first("key")) + " ")]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.languages, function(language) {
                return _c(
                  "div",
                  {
                    key: language.id,
                    staticClass: "form-group m-form__group row"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-lg-12",
                        class: {
                          "has-danger": _vm.errors.has("" + language.locale)
                        }
                      },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm._f("translate")(language.locale)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "input-group m-input-group" },
                          [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "input-group-text",
                                  attrs: { id: "basic-addon" }
                                },
                                [
                                  _c("i", [
                                    _c("img", {
                                      staticClass:
                                        "carousel-control-next-icon icon-flag-selector",
                                      attrs: {
                                        src:
                                          "/media/img/flags/" +
                                          language.locale +
                                          ".png"
                                      }
                                    })
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.phrase[language.locale],
                                  expression: "phrase[language.locale]"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|min:2|max:255",
                                  expression: "'required|min:2|max:255'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                type: "name",
                                name: "" + language.locale
                              },
                              domProps: { value: _vm.phrase[language.locale] },
                              on: {
                                keyup: function($event) {
                                  return _vm.formatPhrase(language.locale)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.phrase,
                                    language.locale,
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("" + language.locale),
                                expression: "errors.has(`${language.locale}`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.errors.first("" + language.locale)) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              })
            ],
            2
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: {
            type: "button",
            "data-dismiss": _vm.openOutside ? "" : "modal",
            id: "btn-cancel"
          },
          on: { click: _vm.resetForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("cancel"))) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button" },
          on: { click: _vm.submitForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("submit"))) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41769902", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41769902","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/languages/phrases/New.vue
// module id = 225
// module chunks = 0 1 55 59 60 63 70 88